import { useParams } from 'react-router-dom';
import { Box, Tooltip } from '@mui/material';
import { useState } from 'react';
import { removeFromQue, getInvoice } from '../../../../../redux/slices/invoicing';
import { useDispatch } from '../../../../../redux/store';
import { AwaitButton } from '../../../../../reusable-components/await-button';
import { useSnackbar } from '../../../../../reusable-components/snackbar';
import { useCanSubmitInvoice } from '../reusable/hooks/useInvoiceLocks';

RemoveFromQue.propTypes = {};
export default function RemoveFromQue() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { canSubmit, message } = useCanSubmitInvoice();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const save = async () => {
    setIsSubmitting(true);
    const response = await dispatch(removeFromQue(id));
    enqueueSnackbar(response.message ? response.message : 'Failed to remove invoice from queue.', {
      variant: response.success ? 'success' : 'error',
    });
    await dispatch(getInvoice(id));
    setIsSubmitting(false);
  };

  return (
    <>
        <Tooltip title={!canSubmit ? message : ''} placement="top" arrow>
        <Box>
          <AwaitButton
            variant="contained"
            color="secondary"
            disabled={!canSubmit}
            onClick={save}
            loading={isSubmitting}
            loadingPosition="start"
            size="small"
          >
            Remove from queue
          </AwaitButton>
        </Box>
      </Tooltip>
    </>
  );
}
